<template>
  <div>
    <!-- actions -->
    <template slot="action">
      <a-button-group style="margin-right: 4px;">
        <a-button>操作</a-button>
        <a-button>操作</a-button>
        <a-button>
          <a-icon type="ellipsis"/>
        </a-button>
      </a-button-group>
      <a-button type="primary">主操作</a-button>
    </template>

    <a-card style="margin-top: 24px" :bordered="false">
      <a-steps :current="currentStep"  v-if="false">
        <a-step v-for="(step,index) in stepList" :key="" index
                :status="currentStep==index?'process': (step.status==2? 'finish':'wait') " :title="step.name"
                :description="step.time_start_str+' 至 '+step.time_end_str"/>
      </a-steps>
      <a-steps :current="currentStep">
        <a-step status="finish" @click="currentStep=0">
          <!-- <span slot="title">Finished</span> -->
          <template slot="title">
            报名准备
          </template>
          <span slot="description"></span>
        </a-step>
        <a-step @click="currentStep=1" :status="currentStep==1?'process':'wait'" title="报名环节" description="距比赛开始40-20天前"/>
        <a-step @click="currentStep=2" :status="currentStep==2?'process':'wait'" title="赛前准备" description="距比赛开始20-3天"/>
        <a-step @click="currentStep=3" :status="currentStep==3?'process':'wait'" title="比赛环节" description=""/>
        <a-step @click="currentStep=4" :status="currentStep==4?'process':'wait'" title="比赛结束" description="比赛结束后5天"/>
      </a-steps>
    </a-card>

    <a-card style=" " :bordered="true"> 
      <a-button @click="handleAdd()">新增任务<a-icon type="plus"/></a-button> 
    </a-card>
    <!-- 操作 -->
    <a-card
        style="margin-top: 24px"
        :bordered="false"
    >
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="CCA任务清单" key="1">
          <a-table
              rowKey="id"
              :columns="serviceLogColumns"
              :dataSource="serviceListf"
              :pagination="false"
          > 
            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
              <span v-html="record.desc"></span>
            </p> 

          <span slot="rank" slot-scope="text,record">
        <template>
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>   
            <span slot="actions" slot-scope="text,record,index">
              <!--<a   >下载</a>-->
              <a  @click="taskEdit(record)">编辑</a>

    <a-divider type="vertical"/>
        <a-popconfirm title="确定删除吗" @confirm="onDelete(record.id)"  okText="确定" cancelText="取消">
          <a href="javascript:;">删除</a>
        </a-popconfirm>
          </span>
          </a-table>

        </a-tab-pane>
        <a-tab-pane tab="省市任务清单" key="2">
          <a-table
              rowKey="id"
              :columns="serviceLogColumns"
              :dataSource="serviceListw"
              :pagination="false"
          > 
            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
              <span v-html="record.desc"></span>
            </p> 

          <span slot="rank" slot-scope="text,record">
        <template>
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>   
            <span slot="actions" slot-scope="text,record,index"> 
              <a   @click="taskEdit(record)">编辑</a>
              <a-divider type="vertical"/> 
        <a-popconfirm title="确定删除吗" @confirm="onDelete(record.id)"  okText="确定" cancelText="取消">
          <a href="javascript:;">删除</a>
        </a-popconfirm>
          </span>
          </a-table>

        </a-tab-pane>
      </a-tabs>


    </a-card>


    <a-affix :offsetBottom="0">
      <div style="background: #fff; padding: 10px 0 20px 10px ; border-top: 1px solid #eee ; text-align: center  ">
        <a-button-group>
          <a-button size="large" style="margin-right: 10px" @click="currentStep--" :disabled="currentStep==0">
            <a-icon type="left"/>
            上一步
          </a-button>
          <a-button size="large" type="primary" @click="currentStep++" :disabled="currentStep==4">下一步
            <a-icon type="right"/>
          </a-button>
        </a-button-group>
      </div>
    </a-affix>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        v-model="taskVisible"
        @ok="handleTaskOk(0)"
    >
      <a-spin :spinning="saveLoading">
        <a-form>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="任务名称"
                  hasFeedback
              > 
                <a-input v-model="taskFormData.name"
                         placeholder="请输入任务名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="任务说明"
                  hasFeedback
              > 
                <a-textarea v-model="taskFormData.desc"
                         placeholder="请输入任务说明"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              
            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="任务类型"
                    hasFeedback
            >
              <a-radio-group  v-model="taskFormData.show_type" buttonStyle="solid">
                <a-radio-button value="app">CCA端</a-radio-button>
                <a-radio-button value="weiyuanhui">省市端</a-radio-button> 
              </a-radio-group>
            </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24"> 
            </a-col>
          </a-row>
           

           
           
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleTaskCancel()">取消</a-button>
  
        <a-button key="save" :loading="saveLoading" @click="handleTaskOk(0)" type="primary">保存</a-button>
      </template>
    </a-modal>


     

  </div>


</template>

<script>
import {mixinDevice} from '@/utils/mixin'
import {getSaiDateDetail, getTaskDetail, taskEdit,setTaskRank,taskAdd,taskDelete} from '@/api/sai'
import {PageView} from '@/components/layouts'
import DetailList from '@/components/tools/DetailList'
import PriceInput from '@/components/PriceInput/'
import PicUploader from '@/components/PicUploader/'
import EditableCell from '@/components/EditableCell/'
import FileUploader from '@/components/FileUploader/'
import RSwitch from '@/components/RSwitch/'

const DetailListItem = DetailList.Item
import {getOrderDetail, orderConfirm, orderUse} from '@/api/shopOrder'

export default {
  name: 'ShopOrderDetail',
  components: {
    PageView,
    FileUploader,
    PicUploader,
    DetailList,
    PriceInput,
    DetailListItem,
    EditableCell,
    RSwitch
  },
  mixins: [mixinDevice],
  data() {
    return {
      currentStep: 0,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      businessNoteEdit: false,
      adminNoteEdit: false,
      saveLoading: false,
      saiqu_id: this.$route.query.id,
      taskVisible: false,
      priceVisible: false,
      refundVisible: false,
      priceFormData: {
        order_goods_id: 0,
        comment: '',
        price: 0
      },
      refundFormData: {
        order_goods_id: 0,
        order_id: 0,
        pay_price: 0,
        refund_price: 0,
        refund_count: 0,
        buy_count: 0,
        count: 0,
        price: 0,
        comment: '',
      },
      taskFormData: {
        id: 0,
        note: '',
        need_upload_file: 2,
        show_type:'',
        score: 0,
        files: [],
        pics: []
      },
      serviceList: [],
      stepList: [],
      saiqu: {},
      logList: [],
      row: {
        buyer: {
          name: '',
          phone: ''
        },
        items: [],
        logList: [{
          user_name: '宋巨报',
          title: '完成了登陆网站测试报名数据',
          create_time: '2020-12-11',
          note: ''
        }],
        serviceList: [
          {
            id: 1,
            step: 0,
            description: '',
            title: '建立工作微信群',
            admin_status: 1,
            admin_user_name: '-',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 2,
            step: 0,
            title: '建立比赛群',
            admin_status: 2,
            description: '',
            admin_user_name: '宋巨报',
            complete_time: '2020-12-17',
            plan_time: '2020-12-12',
          },
          {
            id: 3,
            step: 0,
            title: '登陆网站测试报名数据',
            admin_status: 3,
            description: '',
            admin_user_name: '周婷婷',
            complete_time: '2020-12-11',
            plan_time: '2020-12-12',
          },
          {
            id: 4,
            step: 1,
            title: '新备案单位审核',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 6,
            step: 2,
            title: '访问下载赛事对接报表',
            admin_status: 1,
            description: '上传场地情况图、参数、搭建方案',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 7,
            step: 2,
            title: '制作日程表',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 8,
            step: 2,
            title: '制作组委会名单',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 9,
            step: 2,
            title: '制作开幕式议程',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 10,
            step: 2,
            title: '制作领队会议程',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 11,
            step: 2,
            title: '办公物料清单确认',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 12,
            step: 2,
            title: '场地物料清单确认',
            admin_status: 1,
            description: '确认印刷制品：确认引导牌、背景板、照片墙（横5M*竖4M）、指示牌、欢迎喷绘、回头标、签名墙、横幅、餐券、车证、工作证件、门票、参赛手册、奖金牌、桌前版、号码牌、广告板、席卡、小C小A拍照喷绘、吉祥物、道旗、拱门、空飘等',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 13,
            step: 2,
            title: '媒体邀请名单确认',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 14,
            step: 2,
            title: '赞助清单赛前上传场地协议、赞助协议盖章版',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 15,
            step: 2,
            title: '场地医生到岗时间表确认',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 16,
            step: 2,
            title: '志愿者名单确认',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 17,
            step: 2,
            title: '报名须知和参赛指南下载',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 18,
            step: 2,
            title: '直播分单机位直播和手机直播',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 19,
            step: 3,
            title: '核对秩序册信息',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 20,
            step: 3,
            title: '编排出场顺序',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 21,
            step: 3,
            title: '走场顺序确认',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 22,
            step: 3,
            title: '仲裁录像',
            admin_status: 1,
            admin_user_name: '',
            description: '（一）确定看场地人员，前往勘察场地（详见仲裁录像流程）；<br/>' +
                '（二）确认场地机位高度及位置，现场亮度，电源接口，观众的分布情况；<br/>' +
                '（三）出发前最后测试检查机器，确认物料运输方式是否安全；<br/>' +
                '（四）确认仲裁录像是否正常运行；<br/>' +
                '（五）确认录像是否拷贝以及备份，确认物料齐全上车发回。',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 23,
            step: 3,
            title: '直播',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 24,
            step: 3,
            title: '摄影',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 25,
            step: 3,
            title: '赛事确认报到流程',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 26,
            step: 3,
            title: '安排保护人员',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 27,
            step: 4,
            title: '成绩发布',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 28,
            step: 4,
            title: '上传赛事文件',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 29,
            step: 4,
            title: '费用结算',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          }
        ],
        step_list: [],
        status_data: {
          step: 0,
          buttons: []
        }
      },
      goodsColumns: [
        {
          title: '#',
          dataIndex: 'id'
        },
        {
          title: '商品',
          dataIndex: 'title',
          scopedSlots: {customRender: 'goods'}
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: {customRender: 'count'}
        },
        {
          title: '价格信息',
          dataIndex: 'goods_price',
          scopedSlots: {customRender: 'goods_price'}
        },
        {
          title: '提成',
          dataIndex: 'rewards_price',
          scopedSlots: {customRender: 'rewards_price'}
        },
        // {
        //   title: '操作',
        //   dataIndex: 'actions',
        //   scopedSlots: { customRender: 'actions' }
        // }
      ],
      serviceLogColumns: [
        {
          title: '任务说明',
          dataIndex: 'name',
        }, 
        {
            title: '排序',
            dataIndex: 'rank',
            scopedSlots: {customRender: 'rank'},
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: {customRender: 'actions'}
        }
      ]
    }
  },
  computed: {
    serviceListf: function () {
      let that = this;
      let list = this.serviceList.filter(item => {
        return item.step == that.currentStep && item.show_type == 'app';
      });
      console.log('this.serviceList.filter');
      console.log(list);
      return list;
    },
    serviceListw: function () {
      let that = this;
      let list = this.serviceList.filter(item => {
        return item.step == that.currentStep && item.show_type == 'weiyuanhui';
      });
      console.log('this.serviceList.filter');
      console.log(list);
      return list;
    }
  },

  mounted() {
    let that = this;
    that.getDetail(true);
  },
  methods: {
    getDetail(fresh) {
      let that = this;
      getSaiDateDetail({
        saiqu:0,
        is_tpl: 1
      }).then(res => {
        if(fresh){ 
          that.currentStep = res.data.current_step;
        }
        that.serviceList = res.data.task_list;
        that.stepList = res.data.step_list;
        that.logList = res.data.log_list;
        that.saiqu = res.data.saiqu;
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    handleRefundSave() {

    },
    handlePirceSave() {

    },


    handleAdd() {
      this.taskFormData = {
        id: 0,
        note: '',
        need_upload_file: 2,
        show_type:'',
        score: 0,
        files: [],
        pics: []
      }, 
      this.taskVisible = true;
    },


    taskEdit(record) {
      let that = this;
      that.taskVisible = true;

      getTaskDetail({id: record.id}).then(res => {
        setTimeout(() => {
          console.log('handleEdit')
          that.taskFormData = {...res.data};
        }, 200)
      })


    },
    handleTaskCancel() {
      let that = this;
      that.taskVisible = false;
    },
    handleTaskOk(type) {
      let that = this;
      if(!that.taskFormData.show_type){
        that.$message.error('请选择任务类型');
        return ;
      }
      if(!that.taskFormData.name){
        that.$message.error('请输入名称');
        return ;
      }
      // that.saveLoading = true;
      if(that.taskFormData.id){ 
        taskEdit({
          id: that.taskFormData.id,
          name: that.taskFormData.name,
          show_type: that.taskFormData.show_type,
          desc: that.taskFormData.desc,  
        }).then(res => {
          that.getDetail();
          that.$message.success('保存成功')
          that.taskVisible = false;
          that.saveLoading = false;
        }).catch(err => {
          that.saveLoading = false;
          that.$message.error(err.data.msg)
        })
      }else{ 
        taskAdd({
          step_id: that.stepList[that.currentStep].id,
          step: that.currentStep,
          name: that.taskFormData.name,
          show_type: that.taskFormData.show_type,
          desc: that.taskFormData.desc,  
        }).then(res => {
          that.getDetail();
          that.$message.success('保存成功')
          that.taskVisible = false;
          that.saveLoading = false;
        }).catch(err => {
          that.saveLoading = false;
          that.$message.error(err.data.msg)
        })
      }
    },  
    onRankChange(key, dataIndex, value) {
        let self = this;
        setTaskRank({
            id: key,
            rank: value
        }).then(res => {
            self.getDetail();
        }).catch(err => {
            self.$message.error(err.data.msg)
        })
    },
    onDelete(id ) {
        let self = this;
        taskDelete({
            id: id, 
        }).then(res => {
            self.getDetail();
        }).catch(err => {
            self.$message.error(err.data.msg)
        })
    },
  },
  filters: {}
}
</script>

<style lang="less" scoped>
.detail-layout {
  margin-left: 44px;
}

.text {
  color: rgba(0, 0, 0, .45);
}

.heading {
  color: rgba(0, 0, 0, .85);
  font-size: 20px;
}

.no-data {
  color: rgba(0, 0, 0, .25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}

.mobile {
  .detail-layout {
    margin-left: unset;
  }

  .text {
  }

  .status-list {
    text-align: left;
  }
}

</style>
